// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28SbM","name":"styles_name__3tXv1","phone":"styles_phone__3IpGT"};